module.exports = __webpack_public_path__ + "media/files/sample_eligibility_file_old-bd3fc3a858c9808aa61df370a7e0008c.xlsx";